<ion-header>
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <ion-title>
            <div class="title-wrapper">
              <span class="title-text">
                {{ 'IP_JOURNAL_COPY_EDITOR.TITLE' | transloco }}
              </span>
            </div>
          </ion-title>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-buttons slot="end">
      <ion-button (click)="onCancel()" [attr.aria-label]="'COMMON.CLOSE' | transloco">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-toolbar class="editor-toolbar">
  <ion-buttons id="copyButton" slot="start">
    <ion-button color="success" expand="block" fill="solid" (click)="submit()" [disabled]="form.invalid">
      <i class="action-p-icon pi pi-clone"></i>
      <span class="ion-hide-md-down">&nbsp;{{ 'IP_JOURNAL_COPY_EDITOR.COPY_BUTTON' | transloco }}</span>
    </ion-button>
  </ion-buttons>
</ion-toolbar>

<ion-card>
  <ion-card-content>
    <form [formGroup]="form">
      <ion-grid class="ion-no-padding">
        <ion-row>
          <ion-col size="12" size-md="12">
            <div class="form-section">
              <ion-item-divider>
                <ion-label>{{ 'EVENT_EDITOR.CLIENT' | transloco }}</ion-label>
              </ion-item-divider>
              <ion-item id="clientSelect">
                <app-multiple-client-select
                  formControlName="clientId"
                  [excludeClientId]="clientId"
                ></app-multiple-client-select>
                @if (form.controls.clientId.touched && form.controls.clientId.invalid) {
                  <div class="validation-message">
                    <ion-text color="danger">
                      {{ 'IP_JOURNAL_COPY_EDITOR.VALIDATION.CLIENT_REQUIRED' | transloco }}
                    </ion-text>
                  </div>
                }
              </ion-item>
            </div>
            <div class="form-section">
              <ion-item-divider>
                <ion-label>{{ 'IP_JOURNAL_COPY_EDITOR.STRUCTURE_CHOOSE_TITLE' | transloco }}</ion-label>
              </ion-item-divider>
              <ion-item id="IPEntriesSelect">
                <app-multiple-ip-entries-tree
                  formControlName="IPEntriesSelect"
                  [clientId]="clientId"
                ></app-multiple-ip-entries-tree>
                @if (form.controls.clientId.touched && form.controls.clientId.invalid) {
                  <div class="validation-message">
                    <ion-text color="danger">
                      {{ 'IP_JOURNAL_COPY_EDITOR.VALIDATION.IP_ENTRIES_REQUIRED' | transloco }}
                    </ion-text>
                  </div>
                }
              </ion-item>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  </ion-card-content>
</ion-card>
